module.exports = __webpack_public_path__ + "static/gm-39-1d8dc9750153b59cc3b9408a4b1c3969.jpg";